/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { IdVerificationUpdatedPayloadSideEffectType } from "./IdVerificationUpdatedPayloadSideEffectType";
import type { VerificationStatus } from "./VerificationStatus";

export interface IdVerificationUpdatedPayload {
  side_effect_type: IdVerificationUpdatedPayloadSideEffectType;
  status: VerificationStatus;
}
